<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2026-04-28 09:55:03
 * @LastEditTime: 2026-05-25 14:02:35
 * @LastEditors: hexy 913752270@qq.com
 * @Description  : 
 * @FilePath     : \icps_fb\src\views\platform\ICPS\internetSales\supplyManagement\controlSet\components\debetControl.vue
-->
<template>
  <!-- 供应管控参数设置 -->
  <el-dialog :visible.sync="debetControlDig" width="980px" :close-on-click-modal="false" @open="openSupplySet" @close="closeDig" >
    <span slot="title" class="dialog-title">欠款管控</span>
    <div class="tabtop" style="width: 380px">
      <div v-for="(item, index) in dataTypeList" :key="index" @click="choose(item.status)">
        <div :class="dataType == item.status ? 'active' : 'text'">
          {{ item.value }}
        </div>
      </div>
    </div>
    <div v-if="dataType == 1">
      <div v-for="(item, index) in supplyControlFrom" :key="index">
        <el-row v-if="item.paramX == null" class="textCss" style="margin-top: 24px">
          <el-col :span="4" :offset="2"><span>第{{
            item.controlLevel == 1
            ? "一"
            : item.controlLevel == 2
              ? "二"
              : item.controlLevel == 3
                ? "三"
                : item.controlLevel == 4
                  ? "四"
                  : ""
          }}级管控:&emsp;&emsp;Y&emsp;&emsp;≥</span></el-col>
          <el-col :span="2">
            <el-input v-model="item.paramY" type="number" placeholder="" style="width: 150px">
              <template slot="append">万元</template>
            </el-input>
          </el-col>
        </el-row>
        <el-row v-if="item.paramX !== null"><el-col :offset="4"><span>&emsp;&emsp;或</span></el-col></el-row>
        <el-row v-if="item.paramX !== null" class="textCss">
          <el-col :span="2" :offset="4"><span>&ensp;&ensp;&ensp;&ensp;X&emsp;&emsp;≥</span></el-col>
          <el-col :span="2">
            <el-input v-model="item.paramX" type="number" placeholder="" style="width: 150px">
              <template slot="append">%</template>
            </el-input>
          </el-col>
          <el-col :span="3" :offset="2"><span>且&ensp;&ensp;&ensp;&ensp;Y&emsp;&emsp;≥</span></el-col>
          <el-col :span="2">
            <el-input v-model="item.paramY" type="number" placeholder="" style="width: 150px">
              <template slot="append"> 万元</template>
            </el-input>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-row style="margin-top: 12px"><el-col :offset="2"><span>偏差率X=（上期合同应收款-实时累计回款）/上期合同应收款
          合同欠款绝对额Y=上期合同应收款-实时累计回款</span></el-col></el-row>
    <el-row><el-col :offset="2"><span>备注：以11月4日提交10月资金表为例，上期合同应收款指9月资金表中的合同应收款。</span></el-col></el-row>

    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="closeDig()">关 闭</el-button>
      <el-button class="bottom_all" @click="saveSupplySet">保 存</el-button>
    </span>
  </el-dialog>
</template>
<script>
import {
  querySupplyControlParam,
  updateSupplyControlParam,
} from "@/api/internetSales/supplyManagement.js";
export default {
  props: {
    debetControlDig: {
      type: Boolean,
      default: false,
    },
    low: {
      type: Object,
      default: new Object(),
    },
  },
  data() {
    return {
      dataType: 1,
      //欠款管控表单
      supplyControlFrom: [
        {
          id: "",
          controlLevel: 1,
          paramY: "",
          paramX: null,
        },
        {
          id: "", //修改时传
          controlLevel: 1, //管控等级：1,2,3,4
          paramY: "",
          paramX: "",
        },
        {
          id: "",
          controlLevel: 2,
          paramY: "",
          paramX: null,
        },
        {
          id: "", //修改时传
          controlLevel: 2, //管控等级：1,2,3,4
          paramY: "",
          paramX: "",
        },
        {
          id: "",
          controlLevel: 3,
          paramY: "",
          paramX: null,
        },
        {
          id: "", //修改时传
          controlLevel: 3, //管控等级：1,2,3,4
          paramY: "",
          paramX: "",
        },
        {
          id: "",
          controlLevel: 4,
          paramY: "",
          paramX: null,
        },
        {
          id: "", //修改时传
          controlLevel: 4, //管控等级：1,2,3,4
          paramY: "",
          paramX: "",
        },
      ],
      dataTypeList: [
        {
          value: "常规管控策略",
          status: 1,
        },
        {
          value: "非常规管控策略",
          status: 0,
        },
      ],
    };
  },
  methods: {
    closeDig(){
      this.$emit("closeDig");
    },
    saveSupplySet() {
      let params = {
        controlId: this.low.id,
        paramType: this.low.controlTypeVal,
        paramData: this.supplyControlFrom,
      };
      updateSupplyControlParam(params).then((res) => {
        if (res.code == 1001) {
          this.$message.success("保存成功!");
          this.closeDig()
        }
      });
    },
    openSupplySet() {
      querySupplyControlParam({
        id: this.low.id,
        controlTypeVal: this.low.controlTypeVal,
      }).then((res) => {
        if (res.code == 1001) {
          if (res.data.responseData.length > 0) {
            const sortedArr = JSON.parse(JSON.stringify(res.data.responseData));

            sortedArr.sort((a, b) => {
              const getControlLevel = (val) => {
                if (val === null) {
                  return Number.MIN_SAFE_INTEGER;
                }
                return Number(val) || 0;
              };

              const getParamX = (val) => {
                if (val === null) {
                  return Number.MAX_SAFE_INTEGER; // null映射为极大值，降序时排最前
                }
                return Number(val) || 0;
              };

              const levelA = getControlLevel(a.controlLevel);
              const levelB = getControlLevel(b.controlLevel);
              const xA = getParamX(a.paramX);
              const xB = getParamX(b.paramX);

              const levelDiff = levelA - levelB;
              if (levelDiff !== 0) {
                return levelDiff;
              }

              return xB - xA;
            });

            this.supplyControlFrom = sortedArr;
            console.log(this.supplyControlFrom);
          } else {
            this.supplyControlFrom = this.$options.data().supplyControlFrom;
            this.supplyControlFrom.forEach((item) => {
              item["controlId"] = this.low.id;
            });
          }

          this.dataType = 1;
        }
      });
    },
    choose(num) {
      this.dataType = num;
    },
  },
};
</script>
